import { useState } from "react"
import {
  Flex,
  Box,
  Heading,
  Link,
  Text,
  Button,
  Collapse,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from "@chakra-ui/react"

const FAQ = () => {
  const [expandedContent, setExpandedContent] = useState(false)
  const [hideButtonText, setHideButtonText] = useState("Afiseaza intrebarile")

  const handleHiddenContent = () => {
    if (expandedContent === true) {
      setExpandedContent(false)
      setHideButtonText("Afiseaza intrebarile")
    } else {
      setExpandedContent(true)
      setHideButtonText("Afiseaza mai putin")
    }
  }

  return (
    <Flex
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      marginTop="24px"
    >
      <Box
        backgroundImage={[
          "url(/cez-confort-asigurat/assets/intrebari-si-raspunsuri-mobile.jpg)",
          "url('/cez-confort-asigurat/assets/intrebari-si-raspunsuri.jpg')",
          "url('/cez-confort-asigurat/assets/intrebari-si-raspunsuri.jpg')",
          "url('/cez-confort-asigurat/assets/intrebari-si-raspunsuri.jpg')",
        ]}
        backgroundPosition={["center", "center", "center-top", "center-top"]}
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
        height="50vh"
        width={["80vw", "80vw", "60vw", "60vw"]}
        borderRadius="4px"
      />
      <Flex
        width={["75vw", "75vw", "55vw", "55vw"]}
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        paddingTop="24px"
        paddingBottom="24px"
        marginBottom="24px"
        marginTop="-48px"
        boxShadow="lg"
        backgroundColor="white"
      >
        <Flex
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          paddingLeft="16px"
          paddingRight="16px"
        >
          <Heading textAlign="center">Ai intrebari? Avem raspunsuri!</Heading>
        </Flex>
        <Accordion allowToggle width="100%" marginTop="24px">
          <AccordionItem>
            <AccordionButton paddingTop="16px" paddingBottom="16px">
              <Box flex="1" textAlign="left" fontWeight="bold">
                Trebuie sa platesc in plus pentru serviciile de asigurare?
              </Box>
              <AccordionIcon />
            </AccordionButton>
            <AccordionPanel pb={4}>
              Pentru tariful <strong>CEZ Confort Asigurat</strong> vei plati{" "}
              <strong>
                doar tariful aferent serviciului de furnizare a energiei
                electrice
              </strong>{" "}
              conform art. "E. Tarif contractat, facturare si plata" din
              contractul de furnizare,{" "}
              <strong>fara costuri suplimentare</strong>.
              <br />
              <br />
              Daca ai optat pentru tariful{" "}
              <strong>CEZ Confort Asigurat Plus</strong>, vei beneficia de
              Serviciile de Asistenta Tehnica de Urgenta pentru Casa, platind un
              abonament in valoare de 0,10 lei/zi/loc de consum pe intreaga
              perioada de valabilitate a acestora, respectiv 12 luni (36,5 lei +
              TVA), valoarea acestuia urmand a fi inclusa in pretul
              abonamentului aferent tarifului de energie electrica contractat,
              avand in vedere mandatul primit in acest sens de{" "}
              <strong>CEZ Vanzare S.A</strong> de la{" "}
              <strong>Prestatorul Pointer Systems S.R.L.</strong>
            </AccordionPanel>
          </AccordionItem>
          <AccordionItem>
            <AccordionButton paddingTop="16px" paddingBottom="16px">
              <Box flex="1" textAlign="left" fontWeight="bold">
                Cum primesti indemnizatia in cazul asigurarii de viata si somaj?
              </Box>
              <AccordionIcon />
            </AccordionButton>
            <AccordionPanel pb={4}>
              Plata indemnizatiei de asigurare va fi efectuata in contul de
              client <strong>CEZ Vanzare</strong>, iar indemnizatia de asigurare
              va fi reprezentata de suma fixa asigurata - 150 de lei/luna.
              <br />
              <br />
              Va fi necesar sa prezinti documentele aferente fiecarui risc
              asigurat pentru verificarea eligibilitatii de plata a
              indemnizatiei.
            </AccordionPanel>
          </AccordionItem>
          <AccordionItem>
            <AccordionButton paddingTop="16px" paddingBottom="16px">
              <Box flex="1" textAlign="left" fontWeight="bold">
                Cum primesti despagubirea in cazul asigurarii de protectie
                impotriva daunelor electrice?
              </Box>
              <AccordionIcon />
            </AccordionButton>
            <AccordionPanel pb={4}>
              Suma asigurata aferenta bunurilor electrocasnice este echivalenta
              cu valoarea de achizitie a echipamentului afectat dar nu mai mult
              de 250 de Euro/echipament electrocasnic prevazut in Conditiile de
              Asiguurare.
              <br />
              <br />
              Notificarea daunelor se poate realiza la{" "}
              <strong>
                Compania de Brokeraj Willis Towers Watson Romania Broker de
                Asigurare - Reasigurare S.R.L
              </strong>{" "}
              fara implicarea <strong>Furnizorului CEZ Vanzare</strong>, astfel:
              <br />- La numarul de telefon dedicat:{" "}
              <strong>+40 212 080 666</strong>, numarul este operational de luni
              pana vineri in intervalul orar: 09:00 - 18:00;
              <br />- Prin e-mail la adresa{" "}
              <strong>daune-cez@willistowerswatson.com</strong>;
              <br />- Prin posta la adresa{" "}
              <strong>
                bd. Ion Mihalache, nr. 15-17, etaj 1, camera 5, sector 1,
                Bucuresti
              </strong>
              .
              <br />
              <br />
              Pentru deschiderea dosarului de dauna, Beneficiarul trebuie sa
              furnizeze urmatoarele informatii si documente:
              <br />
              - Documentul de identitate al titularului de contract de
              electricitate si al proprietarului echipamentului;
              <br />
              - Scurta descriere a evenimentului;
              <br />
              - Factura de achizitie a echipamentelor;
              <br />
              - Detaliile de plata cum ar fi IBAN, Banca, nume si prenume;
              <br />
              - Modul preferat de comunicare referitor la dauna si la datele de
              contact.
              <br />
              <br />
              In cazul in care factura nu este disponibila, compania care
              gestioneaza daunele va verifica daca echipamentul avariat
              indeplineste criteriul de vechime (bazat pe anul de fabricatie al
              echipamentului, anul fabricatiei inscris pe echipament, documentul
              de plata al echipamentului din care se poate identifica bunul care
              face obiectul despagubirii).
            </AccordionPanel>
          </AccordionItem>
          <Collapse in={expandedContent}>
            <AccordionItem>
              <AccordionButton paddingTop="16px" paddingBottom="16px">
                <Box flex="1" textAlign="left" fontWeight="bold">
                  Ce inseamna somer?
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel pb={4}>
                Se considera ca este somer orice persoana fizica ce indeplineste
                cumulativ urmatoarele conditii:
                <br />
                <strong>1.</strong> Este in cautarea unui loc de munca de la
                varsta de minimum 16 ani si pana la indeplinirea conditiilor de
                pensionare.
                <br />
                <strong>2.</strong> Starea de sanatate si capacitatile fizice si
                psihice o fac apta pentru prestarea unei munci.
                <br />
                <strong>3.</strong> Nu are loc de munca, nu realizeaza venituri
                sau realizeaza, din activitati autorizate potrivit legii,
                venituri mai mici decat valoarea indicatorului social de
                referinta al asigurarilor pentru somaj si stimularii ocuparii
                fortei de munca, in vigoare.
                <br />
                <strong>4. </strong>Este disponibila sa inceapa lucrul in
                perioada imediat urmatoare, daca s-ar gasi un loc de munca.
                <br />
                <strong>5. </strong>Este inregistrata la agentia pentru ocuparea
                fortei de munca in conditiile prevazute de legislatia in
                vigoare.
              </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
              <AccordionButton paddingTop="16px" paddingBottom="16px">
                <Box flex="1" textAlign="left" fontWeight="bold">
                  Cum pot beneficia de indemnizatie pentru somaj involuntar?
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel pb={4}>
                Trebuie sa furnizezi dovada calitatii de somer conform Legii nr.
                76/2002 privind sistemul asigurarilor pentru somaj si stimularea
                ocuparii fortei de munca, cu completarile si modificarile
                ulterioare:
                <br />
                <strong>a) </strong>Carnet de somer cu viza valabila;
                <br />
                <strong>b) </strong>Copie a deciziei privind motivul incetarii
                raportului de munca cu ultimul angajator;
                <br />
                <strong>c) </strong>Inregistrarea la agentia pentru ocuparea
                fortei de munca in a carei raza teritoriala isi are domiciliul
                sau, dupa caz, resedinta ori la alt furnizor de servicii de
                ocupare, care functioneaza in conditiile prevazute de lege, in
                vederea obtinerii unui loc de munca;
                <br />
                <br />
                In caz de somaj, Asiguratorul acopera totalul de plata lunar
                conform ultimului grafic de rambursare aferent ultimei prime de
                asigurare platite.
                <br />
                <br />
                Daca Asiguratul nu furnizeaza dovada calitatii de somer,
                respectiv a continuarii acesteia prin prezentarea copiei
                certificatului de somer cu viza ANOFM/AJOFM sau adeverinta
                eliberata de ANOFM/AJOFM care atesta prelungirea calitatii de
                somer cu inca 30 de zile, cu cel putin 15 zile inaintea datei
                scadente a fiecarei rate <strong>CEZ Vanzare</strong>, sau daca
                Asiguratul se va angaja in oricare activitate sau ocupatie sau
                va presta orice munca in schimbul unei compensatii sau al unui
                profit, toate ratele <strong>CEZ Vanzare</strong> care devin
                scadente dupa oricare din aceste evenimente se vor suporta de
                catre Asigurat.
              </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
              <AccordionButton paddingTop="16px" paddingBottom="16px">
                <Box flex="1" textAlign="left" fontWeight="bold">
                  Cum esti informat referitor la beneficiile si conditiile
                  produsului CEZ Confort Asigurat?
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel pb={4}>
                Vei fi informat precontractual si pe parcursul derularii
                contractului despre produs si beneficiile acestuia, de catre
                spcialistii <strong>CEZ Vanzare</strong> atat in mod direct, cat
                si indirect, prin intermediul{" "}
                <Link
                  href="https://www.cez.ro/ro/contactati-ne.html"
                  color="brand.500"
                  target="_blank"
                  rel="noopener noreferrer"
                  fontWeight="bold"
                >
                  canalelor noastre de comunicare
                </Link>
                .
                <br />
                <br />
                Ti se vor pune la dispozitie conditiile specifice fiecarei
                asigurari, cererea si certificatul de asigurare, precum si
                documentele de informare privind produsele de asigurare.
              </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
              <AccordionButton paddingTop="16px" paddingBottom="16px">
                <Box flex="1" textAlign="left" fontWeight="bold">
                  Cand trebuie sa anunti in cazul asigurarii de viata si somaj?
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel pb={4}>
                Asiguratul trebuie sa instiinteze in maximum 30 de zile de la
                data confirmarii evenimentului{" "}
                <strong>
                  Compania de Brokeraj Marsh Broker de Asigurare-Reasigurare
                  S.R.L
                </strong>{" "}
                la numerele de telefon dedicate:
                <br />- <strong>0725 351 413 / 0726 384 218</strong> - numere
                operationale in zilele de Luni-Vineri, in intervalul orar: 09:00
                - 16:00
                <br />- e-mail la adresa: <strong>daune_eb@marsh.com</strong>,
                sau asiguratorul <strong>Groupama Asigurari</strong> la adresa
                de e-mail: <strong>documente@groupama.ro</strong>
              </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
              <AccordionButton paddingTop="16px" paddingBottom="16px">
                <Box flex="1" textAlign="left" fontWeight="bold">
                  Cand trebuie sa anunti in cazul asigurarii de protectie
                  impotriva daunelor electrice?
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel pb={4}>
                Asiguratul trebuie sa notifice cat mai repede posibil,
                respectand termenul obligatoriu de avizare de 5 zile de la data
                producerii riscului asigurat, cu exceptia situatiilor in care
                face dovada ca a fost plecat din localitatea locului de consum
                pentru o perioada mai mare de timp.
                <br />
                <br />
                Notificarea daunelor se face la{" "}
                <strong>
                  Compania de Brokeraj Willis Towers Watson Romania Broker de
                  Asigurare - Reasigurare S.R.L
                </strong>
                :
                <br />- La numarul de telefon <strong>+40 212 080 666</strong>,
                numarul este operational de luni pana vineri in intervalul orar:
                09:00 - 18:00;
                <br />- Prin e-mail la adresa{" "}
                <strong>daune_cez@willistowerswatson.com</strong>;
                <br />- Prin posta la adresa{" "}
                <strong>
                  bd. Ion Mihalache, nr. 15-17, etaj 1, camera 5, sector 1,
                  Bucuresti
                </strong>
                .
              </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
              <AccordionButton paddingTop="16px" paddingBottom="16px">
                <Box flex="1" textAlign="left" fontWeight="bold">
                  Cand trebuie sa anunti in cazul urgentelor la instalatia
                  electrica sau sanitara?
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel pb={4}>
                Clientul Beneficiar se obliga sa notifice telefonic Prestatorul
                prin intermediul Call Center la numarul de telefon{" "}
                <strong>0737 999 991</strong> in legatura cu aparitia
                situatiilor de urgenta, in termen de maxim 24 de ore de la
                aparitia acestora. Clientul Beneficiar trebuie sa actioneze
                conform instructiunilor Prestatorului.
              </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
              <AccordionButton paddingTop="16px" paddingBottom="16px">
                <Box flex="1" textAlign="left" fontWeight="bold">
                  Cand incepe si cand inceteaza acoperirea?
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel pb={4}>
                Protectia conferita prin asigurare intra in vigoare la termenul
                de incepere a furnizarii energiei electrice in baza contractului
                de furnizare incheiat cu <strong>CEZ Vanzare</strong> pentru
                produsul <strong>CEZ Confort Asigurat</strong> sau{" "}
                <strong>CEZ Confort Asigurat Plus</strong> si este valabila pe
                toata durata perioadei contractuale.
              </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
              <AccordionButton paddingTop="16px" paddingBottom="16px">
                <Box flex="1" textAlign="left" fontWeight="bold">
                  Ce acoperire au serviciile de asigurare?
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel pb={4}>
                In cazul{" "}
                <strong>
                  asigurarii de protectie impotriva daunelor electrice
                </strong>
                , ea se aplica pentru evenimentele care survin pe teritoriul
                Romaniei la locul de consum pentru care exista in vigoare la
                momentul daunei un contract de furnizare a energiei electrice
                pentru produsul <strong>CEZ Confort Asigurat</strong> sau{" "}
                <strong>CEZ Confort Asigurat Plus</strong>.
                <br />
                <br />
                In cazul <strong>asigurarii de viata si somaj</strong>,
                asigurarea acopera riscurile asigurate produse pe teritoriul
                Romaniei.
              </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
              <AccordionButton paddingTop="16px" paddingBottom="16px">
                <Box flex="1" textAlign="left" fontWeight="bold">
                  Daca am un contract CEZ Confort Asigurat Plus pentru un singur
                  loc de consum, dar mai multe locuri de consum, pot beneficia
                  de servicii de interventie de urgenta la instalatia electrica
                  pentru toate locurile de consum?
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel pb={4}>
                In acest caz, serviciile de interventie de urgenta la instalatia
                electrica sau sanitara se pot solicita si se ofera doar pentru
                locul de consum unde ai incheiat contractul{" "}
                <strong>CEZ Confort Asigurat Plus</strong>.
              </AccordionPanel>
            </AccordionItem>
          </Collapse>
        </Accordion>
        <Flex justifyContent="center" alignItems="center" marginTop="8px">
          <Button onClick={() => handleHiddenContent()}>
            {hideButtonText}
          </Button>
        </Flex>
      </Flex>
      <Flex justifyContent="center" alignItems="center" marginBottom="48px">
        <Text textAlign="center">
          Poti consulta{" "}
          <strong>
            Conditiile Generale pentru serviciul de furnizare a energiei
            electrice
          </strong>{" "}
          -{" "}
          <Link
            color="brand.500"
            href="https://www.cezinfo.ro/wp-content/uploads/2021/01/CONDITII_GENERALE_clienti-casnici-eligibili.pdf"
            target="_blank"
            rel="noopener noreferrer"
            fontWeight="bold"
          >
            aici
          </Link>
        </Text>
      </Flex>
    </Flex>
  )
}

export default FAQ
